module.exports = __webpack_public_path__ + "static/media/J4.f196a817.jpg";